export enum Events {
  inspectionConducted = 'inspectionConducted',
  inspectionDeleted = 'inspectionDeleted',
  subscriptionUpdated = 'subscriptionUpdated',
  bulkDeleteClick = 'click:bulk-delete',
  recordsDeleted = 'records:deleted',
  bulkDeleteClickConfirmation = 'click:bulk-delete-confirmation',
  singleRecordDeleted = 'record:deleted',
  submittedInspection = 'inspection:submit',
  submittedDraftInspection = 'inspection:submit-draft',
  clickedSubmitInspectionButton = 'inspection-button:click',
  userCreated = 'user:created',
  APIKeysRegenerated = 'api-keys:regenerated',
  viewedNewFeature = 'viewed-new-feature',
  submitCreateIssue = 'issue:create',
  updateIssue = 'issue:update',
  seeMoreDetailsIssue = 'issue:see-details',
  fillIssueDetailsInspectionPage = 'issue:fill-details:inspection',
  fillIssueDetailInspectionPageSave = 'issue:fill-details:inspection:submit',
  showErrorsInvalidActions = 'invalid-actions:show-errors',
  preSubmitInspection = 'inspection:pre-submit',
  saveReportTemplate = 'report-template:save',
  bulkUpdateClick = 'click:bulk-update',
}
